import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { TradeClassDirective } from '../../../multisite/trade/trade-class.directive';
import { AbstractPageFooterColumnComponent } from './abstract-page-footer-column.component';
import { IPageFooterColumnMobile } from './page-footer.component';
@Component({
    selector: 'page-footer-column-mobile',
    templateUrl: 'page-footer-column-mobile.html',
    standalone: true,
    imports: [ZippyModule, TradeClassDirective, HrefComponent, ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageFooterColumnMobileComponent extends AbstractPageFooterColumnComponent {
    @Input()
    override column: IPageFooterColumnMobile;
    @Input()
    index: number;
}
